import {
  RestaurantsResponseWithMutipleConfigs,
  RestaurantsResponseWithSingleConfig,
} from '@store/types';

export const mapRestaurantsResponse = (
  restaurants: RestaurantsResponseWithMutipleConfigs[]
): RestaurantsResponseWithSingleConfig[] => {
  const mappedRestaurants: RestaurantsResponseWithSingleConfig[] = restaurants.flatMap(
    ({ name, configs, closedDates, nameDisplay }) => {
      if (!configs) return [];
      return configs.map((config) => ({
        value: config.name,
        restaurantName: name,
        closedDates: closedDates,
        label: config ? config.name : nameDisplay,
        config,
      }));
    }
  );

  return mappedRestaurants;
};
